import styled from "styled-components";
import {Modal, Checkbox, Typography, Divider, Badge, Tag} from "antd";

const {Text, Title} = Typography;

export const StyledModal = styled(Modal)`
    .ant-modal-header {
        border-bottom: 1px solid #f0f0f0;
        padding: 16px 24px;
    }

    .ant-modal-body {
        max-height: 75vh;
        overflow-y: auto;
        padding: 24px;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
    }

    .ant-modal-content {
        border-radius: 8px;
    }
`;

export const ModalTitle = styled(Title)`
    margin: 0 !important;
    display: flex;
    align-items: center;
`;

export const HeaderContainer = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledCheckbox = styled(Checkbox)`
    font-size: 15px;
    font-weight: 500;
`;

export const StyledDivider = styled(Divider)`
    margin: 12px 0;
`;

export const ShipmentList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ShipmentCard = styled.div`
    display: flex;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
    background-color: ${props => (props.selected ? "#f6f9ff" : "white")};
    transition: all 0.3s ease;
    box-shadow: ${props => (props.selected ? "0 2px 8px rgba(0,0,0,0.05)" : "none")};
`;

export const CardCheckbox = styled(Checkbox)`
    margin-right: 16px;
    margin-top: 4px;
`;

export const CardContent = styled.div`
    flex: 1;
`;

export const FieldLabel = styled(Text)`
    font-size: 14px;
    display: block;
    margin-bottom: 4px;
    color: #666;
`;

export const FieldValue = styled.div`
    margin-top: 4px;
    display: flex;
    align-items: center;
    font-size: 15px;
`;

export const StyledTag = styled(Tag)`
    font-size: 14px;
    padding: 4px 8px;
    color: #333;
`;

export const StyledTagStatus = styled(Tag)`
    font-size: 14px;
    padding: 4px 8px;
`;

export const StyledBadge = styled(Badge)`
    .ant-badge-count {
        background-color: #52c41a;
        font-size: 14px;
        padding: 0 8px;
    }
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 40px 0;
    color: #999;
`;

export const SummaryContainer = styled.div`
    margin-top: 20px;
    padding: 12px;
    background-color: #f6ffed;
    border-radius: 4px;
    display: flex;
    align-items: center;
`;

export const ShipmentRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    gap: 16px;
    width: 100%;
    align-items: center;

    @media (max-width: 992px) {
        grid-template-columns: 1fr 1fr 1fr;
        gap: 12px;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
        gap: 8px;
    }
`;

export const ShipmentField = styled.div`
    display: flex;
    flex-direction: column;
`;

export const PacketCount = styled.div`
    display: inline-flex;
    align-items: center;
    background-color: #52c41a;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 14px;
`;

export const PacketNumber = styled.span`
    font-weight: bold;
    margin-right: 4px;
`;

export const StatusField = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ReceiverName = styled.span`
    font-weight: 500;
`;

export const ReceiverAddress = styled.span`
    color: #666;
    font-size: 14px;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  color: #333;
`;

export const TableContainer = styled.div`
  margin-top: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  background-color: white;
  min-height: 200px;
`;
